import { oz } from '@weft/utils';
import { PlanOverviewSchema } from '../get-plan-overview/plan-overview-schema';

export const GetPlansOverviewsResponseSchema = oz.object({
  countedActivePlansOverviews: oz.number().nonnegative(),
  countedTotalPlansOverviews: oz.number().nonnegative(),
  countedFilteredPlansOverviews: oz.number().nonnegative(),
  plansOverviews: oz.array(PlanOverviewSchema),
}).openapi('GetPlansOverviewsResponse');

export type GetPlansOverviewsResponse = oz.infer<typeof GetPlansOverviewsResponseSchema>;